import { Input } from 'components/form';
import React, { useCallback, useState } from 'react';

interface IPasswordHidden {
  name: string;
  placeholder?: string;
  hasValue?: boolean;
}
const PasswordHidden = ({ name, placeholder, hasValue }: IPasswordHidden) => {
  const [isDisplay, setIsDisplay] = useState<boolean>(true);
  const [showIcon, setShowIcon] = useState<boolean>(hasValue ? true : false);

  const handleShowPassword = useCallback(() => {
    setIsDisplay(!isDisplay);
  }, [isDisplay]);

  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setShowIcon(true);
    } else {
      setShowIcon(false);
    }
  };

  return (
    <div className='hidden-block'>
      <div className='hidden-block-container'>
        <Input
          type={!isDisplay ? 'text' : 'password'}
          name={name}
          onChange={handleChangePassword}
          placeholder={placeholder}
        />
      </div>
      <div className='position-absolute icon-hidden'>
        {showIcon &&
          (isDisplay ? (
            <i className='fa fa-eye' onClick={handleShowPassword}></i>
          ) : (
            <i className='fa fa-eye-slash' onClick={handleShowPassword}></i>
          ))}
      </div>
    </div>
  );
};

export default PasswordHidden;
